/* PLEENA · fondo guiado por el scroll.
   Cuatro geometrías que se relevan: líneas → círculos → cuadrados → ondas, y
   vuelta. Cada una se mueve además en horizontal, en vertical y cambia de
   tamaño. Todo va en background-size/position, nunca en transform: un transform
   rompería background-attachment:fixed y volverían los cortes entre secciones.
   Se escribe DIRECTO en cada capa, nunca una custom property en <html>. */
(function () {
  'use strict';
  var html = document.documentElement, capas = [], pedido = false;

  function entre(p, pts) {
    if (p <= pts[0][0]) return pts[0][1];
    for (var i = 1; i < pts.length; i++) {
      if (p <= pts[i][0]) {
        var t = (p - pts[i - 1][0]) / (pts[i][0] - pts[i - 1][0]);
        return pts[i - 1][1] + (pts[i][1] - pts[i - 1][1]) * t;
      }
    }
    return pts[pts.length - 1][1];
  }
  /* curva suave: el cruce entre figuras no se siente mecánico */
  function suave(x) { return x < 0 ? 0 : x > 1 ? 1 : x * x * (3 - 2 * x); }
  /* cuánto pesa una figura alrededor de su momento central */
  function peso(p, centro, ancho) {
    var d = Math.abs(p - centro) / ancho;
    return suave(1 - Math.min(1, d));
  }

  function juntar() {
    capas = [];
    var nodos = document.querySelectorAll('.pl-malla');
    for (var i = 0; i < nodos.length; i++) {
      capas.push({
        lin: nodos[i].querySelector('.pl-malla__p--lineas'),
        cir: nodos[i].querySelector('.pl-malla__p--circulos'),
        cua: nodos[i].querySelector('.pl-malla__p--cuadros'),
        ond: nodos[i].querySelector('.pl-malla__p--ondas'),
        a: nodos[i].querySelector('.pl-malla__glow--1'),
        b: nodos[i].querySelector('.pl-malla__glow--2'),
        c: nodos[i].querySelector('.pl-malla__glow--3')
      });
    }
  }

  function pintar() {
    pedido = false;
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    var p = alto > 0 ? Math.min(1, Math.max(0, (window.pageYOffset || 0) / alto)) : 0;

    /* --- qué figura manda en cada tramo --- */
    var wLin = Math.max(peso(p, 0.00, 0.20), peso(p, 1.00, 0.18));
    var wCir = peso(p, 0.28, 0.20);
    var wCua = peso(p, 0.55, 0.19);
    var wOnd = peso(p, 0.80, 0.19);

    /* --- movimiento horizontal y vertical, distinto para cada una --- */
    var x1 = entre(p, [[0,0],[1,1100]]),  y1 = entre(p, [[0,0],[1,-620]]);
    var x2 = entre(p, [[0,0],[1,-900]]),  y2 = entre(p, [[0,0],[1,780]]);
    var x3 = entre(p, [[0,0],[0.5,700],[1,-500]]), y3 = entre(p, [[0,0],[0.5,-400],[1,650]]);

    /* --- tamaño: cada figura crece y encoge en su propio ciclo --- */
    var sLin = 78 * entre(p, [[0,0.6],[0.2,1.9],[0.45,0.7],[0.7,2.3],[1,0.8]]);
    var sCir = 64 * entre(p, [[0,1.6],[0.28,0.55],[0.6,2.1],[1,0.9]]);
    var sCua = 70 * entre(p, [[0,0.7],[0.35,2.2],[0.55,0.6],[0.85,1.8],[1,1]]);
    var sOnd = 100 * entre(p, [[0,1],[0.5,2.4],[1,0.7]]);

    var vw = window.innerWidth / 100, vh = window.innerHeight / 100;
    var ax = entre(p, [[0,-20],[0.35,45],[0.7,-15],[1,30]]) * vw;
    var ay = entre(p, [[0,10],[0.35,-40],[0.7,35],[1,-20]]) * vh;
    var ae = entre(p, [[0,0.4],[0.35,2.1],[0.7,0.6],[1,1.7]]);
    var bx = entre(p, [[0,25],[0.45,-50],[1,35]]) * vw;
    var by = entre(p, [[0,-15],[0.45,45],[1,-30]]) * vh;
    var be = entre(p, [[0,1.9],[0.45,0.35],[1,2.3]]);
    var cx = entre(p, [[0,-30],[0.40,40],[1,-25]]) * vw;
    var cy = entre(p, [[0,20],[0.40,-45],[1,30]]) * vh;
    var ce = entre(p, [[0,0.5],[0.40,2.4],[1,0.8]]);

    var base = 1;
    for (var i = 0; i < capas.length; i++) {
      var k = capas[i];
      if (k.lin) {
        k.lin.style.opacity = (wLin * 0.5 * base).toFixed(3);
        k.lin.style.backgroundSize = sLin.toFixed(1) + 'px ' + sLin.toFixed(1) + 'px';
        k.lin.style.backgroundPosition = x1.toFixed(0) + 'px ' + y1.toFixed(0) + 'px';
      }
      if (k.cir) {
        k.cir.style.opacity = (wCir * 0.6 * base).toFixed(3);
        k.cir.style.backgroundSize = sCir.toFixed(1) + 'px ' + sCir.toFixed(1) + 'px';
        k.cir.style.backgroundPosition = x2.toFixed(0) + 'px ' + y2.toFixed(0) + 'px';
      }
      if (k.cua) {
        k.cua.style.opacity = (wCua * 0.22 * base).toFixed(3);
        k.cua.style.backgroundSize = sCua.toFixed(1) + 'px ' + sCua.toFixed(1) + 'px';
        k.cua.style.backgroundPosition = x3.toFixed(0) + 'px ' + y3.toFixed(0) + 'px';
      }
      if (k.ond) {
        k.ond.style.opacity = (wOnd * 0.42 * base).toFixed(3);
        k.ond.style.backgroundSize = sOnd.toFixed(0) + '% ' + sOnd.toFixed(0) + '%';
        k.ond.style.backgroundPosition = (x1 * 0.2).toFixed(0) + 'px ' + (y2 * 0.2).toFixed(0) + 'px';
      }
      if (k.a) { k.a.style.transform = 'translate3d(' + ax.toFixed(1) + 'px,' + ay.toFixed(1) + 'px,0) scale(' + ae.toFixed(3) + ')'; }
      if (k.b) { k.b.style.transform = 'translate3d(' + bx.toFixed(1) + 'px,' + by.toFixed(1) + 'px,0) scale(' + be.toFixed(3) + ')'; }
      if (k.c) { k.c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) scale(' + ce.toFixed(3) + ')'; }
    }
  }

  function pedir() { if (!pedido) { pedido = true; requestAnimationFrame(pintar); } }
  function arrancar() { juntar(); pintar(); if (window.console) console.info('[pleena fondo] 4 geometrías en marcha'); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', function () { juntar(); pedir(); }, { passive: true });
  document.addEventListener('shopify:section:load', function () { juntar(); pedir(); });
})();
